import { GlobalState } from '../createStore';

export const tradeDomain = (state: GlobalState) => state.tradeArtworks;
